/** Virtual row for person name + general notes (same table as line items). */
export const META_INVENTORY_KEY = "__screen_meta__";

export function normalizePeriodKey(periodStartedAt) {
  if (periodStartedAt == null || periodStartedAt === "") return "__null__";
  return String(periodStartedAt);
}

/** Browser draft key scoped to one user, site, and server counting period. */
export function countSubmissionStorageKey(userId, siteId, periodStartedAt) {
  return `countSubmission_${userId}_${siteId}_${encodeURIComponent(normalizePeriodKey(periodStartedAt))}`;
}

/** Pre-period-scoping key retained only for safe, same-period migration. */
export function legacyCountSubmissionStorageKey(userId, siteId) {
  return `countSubmission_${userId}_${siteId}`;
}

/**
 * localStorage / legacy draft is stale for the active counting period.
 * - Missing periodStartedAt while server has a period → stale
 * - Mismatched periodStartedAt → stale
 */
export function isLocalDraftStaleForPeriod(parsed, countingPeriodStartedAt) {
  if (!parsed || typeof parsed !== "object") return true;
  if (countingPeriodStartedAt != null && countingPeriodStartedAt !== "") {
    if (parsed.periodStartedAt === undefined) return true;
    return normalizePeriodKey(parsed.periodStartedAt) !== normalizePeriodKey(countingPeriodStartedAt);
  }
  if (parsed.periodStartedAt !== undefined && parsed.periodStartedAt != null && parsed.periodStartedAt !== "") {
    // Client has a period stamp but server has none — treat as stale to be safe
    return true;
  }
  return false;
}

/**
 * Server bulk draft is stale when updatedAt/savedAt predates countingPeriodStartedAt.
 * Undated drafts are stale when a period is set.
 */
export function isServerDraftStaleForPeriod(draft, countingPeriodStartedAt) {
  if (countingPeriodStartedAt == null || countingPeriodStartedAt === "") return false;
  const periodMs = new Date(countingPeriodStartedAt).getTime();
  if (Number.isNaN(periodMs)) return false;
  if (!draft) return true;
  const ts = draft.updatedAt || draft.savedAt || null;
  if (!ts) return true;
  const draftMs = new Date(ts).getTime();
  if (Number.isNaN(draftMs)) return true;
  return draftMs < periodMs;
}

export function isOfflineDraftsEnabled() {
  if (typeof window === "undefined") return false;
  try {
    if (window.localStorage.getItem("si_offline_drafts_disabled") === "1") return false;
  } catch (_) {}
  return process.env.REACT_APP_OFFLINE_COUNT_DRAFTS !== "false";
}

export function draftCompositeId(tenantId, userId, siteId, periodKey, inventoryItemId) {
  return `${tenantId}|${userId}|${siteId}|${periodKey}|${inventoryItemId}`;
}


// EOF
